// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ItemList-module__item-list{width:100%;margin-bottom:1em}", "",{"version":3,"sources":["webpack://./src/components/cart/ItemList/ItemList.module.scss"],"names":[],"mappings":"AAAA,4BACE,UAAA,CACA,iBAAA","sourcesContent":[".item-list {\n  width: 100%;\n  margin-bottom: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item-list": "ItemList-module__item-list",
	"itemList": "ItemList-module__item-list"
};
export default ___CSS_LOADER_EXPORT___;
